function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.833496 7.99968C0.833496 4.04164 4.04211 0.833008 8.00016 0.833008C11.9582 0.833008 15.1668 4.04164 15.1668 7.99968C15.1668 11.9577 11.9582 15.1664 8.00016 15.1664C4.04211 15.1664 0.833496 11.9577 0.833496 7.99968ZM8.00016 1.83301C4.5944 1.83301 1.8335 4.59392 1.8335 7.99968C1.8335 11.4054 4.5944 14.1664 8.00016 14.1664C11.4059 14.1664 14.1668 11.4054 14.1668 7.99968C14.1668 4.59391 11.4059 1.83301 8.00016 1.83301ZM8 4.83301C8.27614 4.83301 8.5 5.05687 8.5 5.33301V7.5H10.6668C10.9429 7.5 11.1668 7.72386 11.1668 8C11.1668 8.27614 10.9429 8.5 10.6668 8.5H8.5V10.6664C8.5 10.9425 8.27614 11.1664 8 11.1664C7.72386 11.1664 7.5 10.9425 7.5 10.6664V8.5H5.3335C5.05735 8.5 4.8335 8.27614 4.8335 8C4.8335 7.72386 5.05735 7.5 5.3335 7.5H7.5V5.33301C7.5 5.05687 7.72386 4.83301 8 4.83301Z",
  fill: "#27262A"
});

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.a5b4d998.svg";
export { ForwardRef as ReactComponent };